export enum InsuranceHistoryType {
  Oc = 'ocInsuranceHistory',
  Ac = 'acInsuranceHistory',
}
